
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1287_15173)"}},[_c('path',{attrs:{"d":"M12.098 3.229l2.673 2.674M5.25 5.25H2.437a.938.938 0 00-.937.938v9.375a.937.937 0 00.938.937H12.75a.938.938 0 00.938-.938v-4.218m2.258-9.29a1.89 1.89 0 010 2.674L9.53 11.144l-3.343.669.669-3.343 6.416-6.416a1.888 1.888 0 012.674 0v0z","stroke":"currentColor","stroke-width":"1.875","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1287_15173"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    